<div class="buttons float-end">
  <button class="btn btn-outline-primary" (click)="createCandidate()">
    <div class="button-text">
      <span class="material-symbols-outlined"> person_add </span>
      <small class="d-none d-lg-block">Nouveau</small>
    </div>
  </button>
</div>
